import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import type { ElementType, HTMLAttributes, ReactNode } from 'react';
import styles from './FAQSection.module.scss';
export type FAQSectionAs = 'section' | 'div';
export type FAQSectionTitleAs = 'h2' | 'h3';
/**
 * `inverse`: the FAQ on a dark band (the page supplies the colour: forever21's
 * partner band); a band pads P inside on the section rhythm. The space around
 * the section is the rhythm's: P above it, nothing below it.
 */
export type FAQSectionTone = 'default' | 'inverse';
export interface FAQSectionProps extends Omit<HTMLAttributes<HTMLElement>, 'className' | 'style' | 'title'> {
  as?: FAQSectionAs;
  children: ReactNode;
  className?: never;
  style?: never;
  title?: ReactNode;
  titleAs?: FAQSectionTitleAs;
  tone?: FAQSectionTone;
}
const TONE_CLASS_NAMES: Record<FAQSectionTone, string | undefined> = {
  default: undefined,
  inverse: styles['helios-faq-section--tone-inverse']
};
function FAQSection(t0) {
  const $ = _c(19);
  let children;
  let props;
  let t1;
  let t2;
  let t3;
  let title;
  if ($[0] !== t0) {
    const {
      as: t4,
      children: t5,
      className: _className,
      style: _style,
      title: t6,
      titleAs: t7,
      tone: t8,
      ...t9
    } = t0;
    t1 = t4;
    children = t5;
    title = t6;
    t2 = t7;
    t3 = t8;
    props = t9;
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = title;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    title = $[6];
  }
  const as = t1 === undefined ? "section" : t1;
  const titleAs = t2 === undefined ? "h2" : t2;
  const tone = t3 === undefined ? "default" : t3;
  const Component = as as ElementType;
  const Title = titleAs as ElementType;
  const t4 = tone === "inverse" ? "padded" : undefined;
  const t5 = TONE_CLASS_NAMES[tone];
  let t6;
  if ($[7] !== t5) {
    t6 = classNames(styles["helios-faq-section"], t5);
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== Title || $[10] !== children || $[11] !== title) {
    t7 = title ? <div className={styles["helios-faq-section__container"]}><div className={styles["helios-faq-section__grid"]}><div className={styles["helios-faq-section__header"]}><Title className={styles["helios-faq-section__title"]}>{title}</Title></div><div className={styles["helios-faq-section__content"]}>{children}</div></div></div> : children;
    $[9] = Title;
    $[10] = children;
    $[11] = title;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== Component || $[14] !== props || $[15] !== t4 || $[16] !== t6 || $[17] !== t7) {
    t8 = <Component {...props} data-helios-band={t4} data-helios-faq-section="" data-helios-section="" className={t6}>{t7}</Component>;
    $[13] = Component;
    $[14] = props;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}
export default FAQSection;